<template>
  <v-container>

    <stock-result
        v-if="done"
        :remove-transaction="removeTransaction"
        :add-transaction="addTransaction"
    />

    <v-row v-else>
      <v-col v-for="(item,index) in getItems" :key="index" cols="12" md="4">
        <product-stock
            :product="item.product"
            v-model="item.regularize"
            :in-stock="item.quantity"
            :minimum="item.minimum"
        >
        </product-stock>
      </v-col>
      <v-col cols="12" class="text-right">
        <submit-button @click="regularizeStock"></submit-button>

      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import ProductStock from "@/modules/delivery/components/ProductStock/ProductStock";
import {SubmitButton} from '@dracul/common-frontend'
import StockOperationProvider from "@/modules/delivery/providers/StockOperationProvider";
import StockResult from "@/modules/delivery/pages/stock/StockOperationPage/StockResult/StockResult";

export default {
  name: "StockRegularize",
  components: {StockResult, ProductStock, SubmitButton},
  props: {
    stock: Object,
  },
  data() {
    return {
      items: [],
      addTransaction: null,
      removeTransaction: null,
      done: false
    }
  },
  computed:{
    getItems(){
      return this.stock.items.filter(i => i.hide === false)
    },
    getRegularizeItems(){
      return this.stock.items.filter(i => i.regularize > 0).map(i=> ({product: i.product.id, quantity:i.regularize}))
    },
  },
  methods: {
    regularizeStock() {
      StockOperationProvider.regularizeStockOperation(this.stock.id, this.getRegularizeItems)
      .then((r)=> {
        console.log("stockRegularize",r)
        console.log(r.data.regularizeStockOperation)
        this.addTransaction = r.data.regularizeStockOperation.addTransaction
        this.removeTransaction = r.data.regularizeStockOperation.removeTransaction
        this.done = true
        this.$emit('stockRegularize',r)
      })
    }
  }
}
</script>

<style scoped>

</style>
